import * as _ from 'lodash';
import { PaymentGroupModel, paymentGroupInstanceTypes, remunerationTypeOrder } from "../PaymentGroupModel";
import { PaymentModel } from "../PaymentModel";
import { certificationStates, remunerationOperations } from '../../objects/Payslip';

/**
 * @typedef { import("../../objects/Payslip").Remuneration } Remuneration
 */

export class ComplexGroupModel extends PaymentGroupModel {
    /**
     * @param { PayslipModel } payslipModel
     * @param { Remuneration } remuneration
     */

    constructor(payslipModel, remuneration) {
        super(payslipModel);
        this.remuneration = remuneration;
        this.operation = remunerationOperations.none;
        this.claim = remuneration.Claim || null;
        /** @type {PaymentModel[]} */
        this.payments = _.map(remuneration.Payments, x => PaymentModel.fromOriginal(this, x));
        this.hasActivePayments = _.some(this.payments, x => !x.payment.IsLocked);
        /** @type {string?} */
        this._message = null;
        this.sortPayments();
    }

    get paymentGroupInstanceType() {
        return paymentGroupInstanceTypes.complex;
    }

    get isRejected() {
        return this.remuneration.CertificationState === certificationStates.rejected;
    }

    get isRecalled() {
        return this.remuneration.CertificationState === certificationStates.recalled;
    }

    get willCertify() {
        return this.operation === remunerationOperations.certify;
    }

    get willRejectClaim() {
        return this.operation === remunerationOperations.rejectClaim;
    }

    /**
     * 
     * @param {PaymentGroupModel} other 
     */
    compareTo(other) {
        if (!(other instanceof ComplexGroupModel)) return 0;
        return remunerationTypeOrder(this.remuneration.RemunerationType) - remunerationTypeOrder(other.remuneration.RemunerationType);
    }

    respondCertify(message) {
        this.operation = remunerationOperations.certify;
        this.message = message;
        this.payslipModel.paymentGroupChanged(this);
    }

    respondRejectClaim(message) {
        this.operation = remunerationOperations.rejectClaim;
        this.message = message;
        this.payslipModel.paymentGroupChanged(this);
    }

    clearResponse() {
        this.operation = remunerationOperations.none;
        this.message = null;
        this.payslipModel.paymentGroupChanged(this);
    }

    getTotalAmount() {
        if (this.operation === remunerationOperations.remove || this.operation === remunerationOperations.rejectClaim) {
            return 0;
        }
        return super.getTotalAmount();
    }

    checkChanges() {
        return this.operation !== remunerationOperations.none || super.checkChanges();
    }

    createUpdate() {
        let update = super.createUpdate();
        update.Operation = this.operation;
        update.Message = this.message;
        return update;
    }
    
    _paymentsChanged() {
        this.hasActivePayments = _.some(this.payments, x => !x.payment.IsLocked);
        if (!this.hasActivePayments) {
            this.operation = remunerationOperations.none;
            this.certificationMessage = null;
        }
    }

    /**
     * @param {PayslipModel} payslipModel
     * @param { Remuneration } remuneration
     */
    static create(payslipModel, remuneration) {
        return new ComplexGroupModel(payslipModel, remuneration);
    }
}